
const Footer = () => {
    return (
        <div className="w-screen h-6 relative top-72 bg-dark-base px-16 flex justify-between text-white py-10 items-center">
            <p>&#9400; Lara Misia Forlani - 2025</p>
            <p>{process.env.REACT_APP_MY_EMAIL}</p>
        </div>
    )
}

export default Footer;